import Vue from 'vue';
import VueI18n from 'vue-i18n';
import es from './lang/es'
import en from './lang/en.js'
import pt from './lang/pt.js'
import store from './utils/store/store.js';

Vue.use(VueI18n);

const messages = {
    es: es,
    en: en,
    pt: pt
};

const locale = store.state.language ? store.state.language : (navigator.language || navigator.userLanguage).split("-")[0];

const i18n = new VueI18n({
    locale: locale, // set locale
    fallbackLocale: 'es',
    messages, // set locale messages
});


export default i18n;